import { Info, LifeBuoy, Crown, Flag, User, Zap } from "lucide-react";
import { Layout } from "@/components/Layout";
import { LEVEL_DESCRIPTIONS, PREMIUM_BENEFITS, BONUS_ONLY_NOTE } from "@/lib/siteContent";
const ZONES = [
  { id: "casual", name: "NEW JACK", access: "FREE" },
  { id: "golden_era", name: "TRIPLE OG", access: "PREMIUM" },
];

const HELP = [
  { icon: User, label: "Account & Login", text: "Manage your profile and session from the Profile page. Trouble signing in? Try again from the Sign In screen." },
  { icon: Crown, label: "Premium & Payment", text: "Start, view, or manage your subscription on the Premium page, including the secure billing portal." },
  { icon: Flag, label: "Puzzle Problems", text: "Spot a wrong clue or answer? Use the Report button on any puzzle to send it straight to our team." },
  { icon: Zap, label: "Technical Issues", text: "Something not working right? Email us the details and we'll help you get back to solving." },
];

export default function About() {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12" data-testid="about-page">
        {/* ABOUT */}
        <section data-testid="about-section" className="mb-16">
          <div className="flex items-center gap-3 mb-3">
            <Info className="text-primary" size={26} />
            <h1 className="font-display text-4xl sm:text-5xl">ABOUT HHKD</h1>
          </div>
          <p className="text-muted-foreground text-base leading-relaxed mb-4">
            <strong className="text-foreground">Hip Hop is bigger than a playlist.</strong>
          </p>
          <p className="text-muted-foreground text-base leading-relaxed mb-4">It's the stories behind the records, the people behind the sound, and the moments that shaped the culture.</p>
          <p className="text-muted-foreground text-base leading-relaxed mb-4">HHKD puts that knowledge to the test, one crossword at a time. Some answers you'll know off top. Others might make you dig a little deeper.</p>
          <p className="text-muted-foreground text-base leading-relaxed">From 1972 to right now, there's always something to learn.</p>
        </section>

        <section className="mb-16" data-testid="about-levels">
          <h2 className="font-display text-3xl sm:text-4xl mb-4">CHOOSE YOUR LEVEL</h2>
          <p className="text-muted-foreground text-base leading-relaxed mb-6">Both levels cover Hip Hop from 1972 to the present. The difference is difficulty, not historical era.</p>
          <div className="grid sm:grid-cols-2 gap-4">
            {ZONES.map((z) => (
              <div key={z.name} data-testid={`about-level-${z.id}`} className="border border-white/15 bg-card p-5">
                <h3 className="font-display text-2xl leading-none mb-2">{z.name} — {z.access}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{LEVEL_DESCRIPTIONS[z.id]}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-16" data-testid="about-premium">
          <div className="flex items-center gap-3 mb-3">
            <Crown className="text-primary shrink-0" size={26} />
            <h2 className="font-display text-3xl sm:text-4xl">WHAT PREMIUM GETS YOU</h2>
          </div>
          <div className="border border-yellow-400 p-5">
            <p className="mb-3">New Jack is always free.</p>
            <p className="font-bold mb-4">PREMIUM — $2.99/MONTH</p>
            <ul className="list-disc pl-5 space-y-3 text-sm" data-testid="premium-benefits">
              {PREMIUM_BENEFITS.map(benefit => <li key={benefit}>{benefit}</li>)}
            </ul>
            <p className="mt-5 text-muted-foreground text-sm leading-relaxed">{BONUS_ONLY_NOTE}</p>
          </div>
        </section>

        {/* SUPPORT */}
        <section data-testid="support-section">
          <div className="flex items-center gap-3 mb-3">
            <LifeBuoy className="text-primary" size={26} />
            <h2 className="font-display text-4xl sm:text-5xl">SUPPORT</h2>
          </div>
          <p className="text-muted-foreground text-base leading-relaxed mb-8">
            Need a hand with your account, Premium, a payment, login, a puzzle, or a technical hiccup?
            Here's how to get help fast.
          </p>
          <div className="grid sm:grid-cols-2 gap-4 mb-10">
            {HELP.map((h) => {
              const Icon = h.icon;
              return (
                <div key={h.label} onClick={h.label === "Premium & Payment" ? () => (window.location.href = "/premium") : undefined} className="border border-white/15 bg-card p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon className="text-primary" size={16} />
                    <span className="font-mono-caps text-[11px] text-foreground">{h.label}</span>
                  </div>
                  <p className="text-muted-foreground text-sm leading-relaxed">{h.text}</p>
                </div>
              );
            })}
          </div>
<a
  href="mailto:hiphopknowledgedrop@gmail.com"
  className="inline-block mb-8 border border-yellow-400 px-5 py-3 font-bold text-yellow-400"
>
  CONTACT SUPPORT
</a>
          
</section>  
  </div>
  </Layout> 
  );
}
